import React from 'react';
import PropTypes from 'prop-types';
import { Box, Grid } from 'grommet';
import MetricCard from './MetricCard';

const PostEventSummaryCards = ({
  kpiStats,
  urlSpikePct,
  trafficSpikePct,
  domainsSpikePct,
  postEventRevenueLossRangeLow,
  postEventRevenueLossRangeHigh,
  formatCurrency,
  highlightBoxShadow = null,
  textColor = 'var(--page-primary-text)',
  subLabelColor = 'var(--page-hint-text)',
}) => (
  <>
    <Grid columns={['1fr', '1fr', '1fr']} gap="0.75rem">
      <MetricCard
        label="PRE + EVENT LINKS"
        value={kpiStats.totalInfringingLinks}
        subLabel="Combined total links"
        cardAccent="var(--page-alt-bg)"
        textColor={textColor}
        subLabelColor={subLabelColor}
      />
      <MetricCard
        label="PRE + EVENT UNIQUE DOMAINS"
        value={kpiStats.totalUniqueDomains}
        subLabel="Combined unique domains"
        cardAccent="var(--page-alt-bg)"
        textColor={textColor}
        subLabelColor={subLabelColor}
      />
      <MetricCard
        label="PRE + EVENT TOTAL VIEWERS"
        value={kpiStats.uniqueVisitorsCount}
        subLabel="Combined unique viewers"
        cardAccent="var(--page-alt-bg)"
        textColor={textColor}
        subLabelColor={subLabelColor}
      />
      <MetricCard
        label="EVENT-DAY URL SPIKE VS PRE"
        value={`${urlSpikePct}%`}
        subLabel="Spike in links"
        cardAccent="var(--page-alt-bg)"
        textColor={textColor}
        subLabelColor={subLabelColor}
      />
      <MetricCard
        label="EVENT-DAY TRAFFIC SPIKE VS PRE"
        value={`${trafficSpikePct}%`}
        subLabel="Spike in traffic"
        cardAccent="var(--page-alt-bg)"
        textColor={textColor}
        subLabelColor={subLabelColor}
      />
      <MetricCard
        label="EVENT-DAY DOMAIN SPIKE VS PRE"
        value={`${domainsSpikePct}%`}
        subLabel="Spike in domains"
        cardAccent="var(--page-alt-bg)"
        textColor={textColor}
        subLabelColor={subLabelColor}
      />
    </Grid>
    <Box pad={{ top: '1rem' }}>
      <MetricCard
        label="TOTAL REVENUE LOSS RANGE"
        value={`${formatCurrency(postEventRevenueLossRangeLow)} - ${formatCurrency(postEventRevenueLossRangeHigh)}`}
        subLabel="Sensitivity range from Pre-Event + Event Day totals"
        cardAccent="var(--page-alt-bg)"
        textColor={textColor}
        subLabelColor={subLabelColor}
        borderColor="var(--page-highlight)"
        boxShadow={highlightBoxShadow}
        large
      />
    </Box>
  </>
);

PostEventSummaryCards.propTypes = {
  kpiStats: PropTypes.object.isRequired,
  urlSpikePct: PropTypes.number.isRequired,
  trafficSpikePct: PropTypes.number.isRequired,
  domainsSpikePct: PropTypes.number.isRequired,
  postEventRevenueLossRangeLow: PropTypes.number.isRequired,
  postEventRevenueLossRangeHigh: PropTypes.number.isRequired,
  formatCurrency: PropTypes.func.isRequired,
  highlightBoxShadow: PropTypes.string,
  textColor: PropTypes.string,
  subLabelColor: PropTypes.string,
};

export default PostEventSummaryCards;
